import { gql } from '@apollo/client';

export const GET_TOTAL_ZIPCODES_COUNT = gql`
  query GetTotalZipcodesCount($warehouseId: Long!) {
    getTotalZipcodesCountByWarehouseId(warehouseId: $warehouseId)
  }
`;

export interface TotalZipcodesCountResponse {
  getTotalZipcodesCountByWarehouseId: number;
}

export interface TotalZipcodesCountVariables {
  warehouseId: number;
}
